/**
 *存放页面跳转之间携带的参数
 */

const collision = {
    name: 'collision',
    namespaced: true,
    state: {
        // 碰撞线索列表参数
        collisionList: {},
        // 不回店统计分析参数
        notBackStatistics: {},
    },
    actions: {
        setCollisionListParams({ commit }, collisionList) {
            commit('SET_STATE', {
                collisionList,
            });
        },
        setNotBackParams({ commit }, notBackStatistics) {
            commit('SET_STATE', {
                notBackStatistics,
            });
        },
    },
};

export default collision;
